export type KeycloakRealm = 'dev' | 'prd' | 'sbx' | 'stg' | 'tst';

export enum AppEnvironment {
  LOCAL = 'local',
  DEV = 'dev',
  TEST = 'tst',
  STAGING = 'stg',
  SANDBOX = 'sbx',
  PROD = 'prd',
}

export interface AppSettings {
  baseurl: string;
  apiUrl: string;
  environment: AppEnvironment;
  ga_id: string;
  googleMapsApiKey: string;
  turnstileSiteKey: string;
  keycloakRealm: KeycloakRealm;
  sentry_enabled: boolean;
  sentryDSN: string | null;
  stripe_api_key: string;
  openreplayProjectKey: string;
  openreplayIngestPoint: string;
}
